import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { MobilePhoneFab } from "@/components/MobilePhoneFab";
import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Produkte from "@/pages/Produkte";
import Unternehmen from "@/pages/Unternehmen";
import Karriere from "@/pages/Karriere";
import Jubilaeum from "@/pages/Jubilaeum";
import Ausstellung from "@/pages/Ausstellung";
import Auszeichnungen from "@/pages/Auszeichnungen";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
        return;
      }
    }
    window.scrollTo({ top: 0 });
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/leistungen" element={<Leistungen />} />
          <Route path="/produkte" element={<Produkte />} />
          <Route path="/unternehmen" element={<Unternehmen />} />
          <Route path="/unternehmen/karriere" element={<Karriere />} />
          <Route path="/unternehmen/50-jahre" element={<Jubilaeum />} />
          <Route path="/unternehmen/ausstellung" element={<Ausstellung />} />
          <Route path="/unternehmen/auszeichnungen" element={<Auszeichnungen />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <MobilePhoneFab />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
